import { render, staticRenderFns } from "./ReportList.vue?vue&type=template&id=0ffaeadb"
import script from "./ReportList.vue?vue&type=script&lang=js"
export * from "./ReportList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports